import { number } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const VolumetricItem = iotsUtils.makePartialRecordDecoder(
	constants.job.volumetrics.measurementTypes,
	number
);
